<template>
    <div class="upload-dragger pb-4">
        <a-upload-dragger
            :name="name"
            :file-list="modelValue"
            :multiple="multiple"
            :before-upload="beforeUploadFile"
            @remove="handleRemove"
        >
            <p class="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p class="ant-upload-text">{{ upload_text }}</p>
            <p class="ant-upload-hint">{{ upload_hint }}</p>
        </a-upload-dragger>
    </div>
</template>

<script>
import { InboxOutlined } from '@ant-design/icons-vue';

export default {
    components: { InboxOutlined },
    data() {
        return {
            file_list: [],
            start_value: null,
            end_value: null,
            end_open: false,
        };
    },
    props: {
        name: {
            type: String,
            default: 'file',
        },
        modelValue: {
            type: Array,
            default: [],
        },
        multiple: {
            type: Boolean,
            default: true,
        },
        upload_text: {
            type: String,
            default: true,
        },
        upload_hint: {
            type: String,
            default: true,
        },
        fileLimit: {
            type: Number,
            default: -3,
        },
        valid_types: {
            type: Array,
            default: [
                'text/csv',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            ],
        },
        valid_types_error: {
            type: String,
            default: 'CSV, XSL or XSLX',
        },
    },
    mounted() {
        this.file_list = this.modelValue;
    },
    methods: {
        handleRemove(file) {
            const index = this.value.indexOf(file);
            const new_value = this.value.slice();

            new_value.splice(index, 1);

            this.file_list = new_value;

            this.$emit('update:modelValue', this.file_list);
        },
        beforeUploadFile(file) {
            if (this.valid_types.includes(file.type)) {
                if (this.file_list.some((value) => value.name.toLowerCase() == file.name.toLowerCase())) {
                    this.$notification.error({
                        message: this.$t('validation.exists_already', { attribute: 'file' }),
                    });
                } else {
                    this.file_list = [...this.file_list, file].slice(this.fileLimit);

                    this.$emit('update:modelValue', this.file_list);
                }
            } else {
                this.$notification.error({
                    message: this.$t('validation.mimes', { attribute: 'File', values: this.valid_types_error }),
                });
            }

            return false;
        },
    },
};
</script>
